/**
 * Rotas do painel.
 *
 * A tela de usuários chega na Task 13. Aqui existe o lugar dela, já protegido pela guarda, para que
 * a estrutura de autorização seja verificável desde agora.
 */

import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import { ProvedorAutenticacao } from './autenticacao/contexto.tsx';
import { ApenasAnonimo, ExigeAutenticacao, ExigePermissao } from './autenticacao/Guardas.tsx';
import { TelaConstrutor } from './construtor/TelaConstrutor.tsx';
import { TelaEdicao } from './construtor/TelaEdicao.tsx';
import { Shell } from './telas/Shell.tsx';
import { TelaAutenticacao } from './telas/TelaAutenticacao.tsx';
import { TelaDashboard } from './telas/TelaDashboard.tsx';
import { TelaMeuPerfil } from './telas/TelaMeuPerfil.tsx';
import { TelaPropostas } from './telas/TelaPropostas.tsx';
import { TelaRelatorios } from './telas/TelaRelatorios.tsx';
import { TelaUsuarios } from './telas/TelaUsuarios.tsx';

export function App() {
  return (
    <ProvedorAutenticacao>
      <BrowserRouter>
        <Routes>
          <Route
            path="/entrar"
            element={
              <ApenasAnonimo>
                <TelaAutenticacao />
              </ApenasAnonimo>
            }
          />

          <Route
            element={
              <ExigeAutenticacao>
                <Shell />
              </ExigeAutenticacao>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />

            <Route path="/dashboard" element={<TelaDashboard />} />

            <Route path="/meu-perfil" element={<TelaMeuPerfil />} />

            <Route path="/propostas" element={<TelaPropostas />} />

            <Route
              path="/nova"
              element={
                <ExigePermissao acao="criar">
                  <TelaConstrutor />
                </ExigePermissao>
              }
            />

            <Route
              path="/editar/:numero"
              element={
                <ExigePermissao acao="ver_proprias">
                  <TelaEdicao />
                </ExigePermissao>
              }
            />

            <Route
              path="/usuarios"
              element={
                <ExigePermissao acao="gerenciar_usuarios">
                  <TelaUsuarios />
                </ExigePermissao>
              }
            />

            <Route
              path="/relatorios"
              element={
                <ExigePermissao acao="ver_auditoria">
                  <TelaRelatorios />
                </ExigePermissao>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ProvedorAutenticacao>
  );
}
